export default __webpack_public_path__ + "static/media/fm.db691c5b.svg";